"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var currency_formatter_1 = __importDefault(require("currency-formatter"));
var FormatCurrency_1 = require("./FormatCurrency");
var GetDecimalPlaces_1 = require("./GetDecimalPlaces");
var QuoteCurrencyFormatter = (function () {
    function QuoteCurrencyFormatter(block, currencyLocaleProvider) {
        var _this = this;
        this.block = block;
        this.currencyLocaleProvider = currencyLocaleProvider;
        this.format = function (amount, precision, overrideCurrency) {
            var code = overrideCurrency || _this.getCurrencyCode();
            return (0, FormatCurrency_1.formatCurrency)(amount, code, precision, _this.currencyLocaleProvider.currencyLocale);
        };
        this.formatWithUserDecimalPreference = function (amount, _a) {
            var _b = _a === void 0 ? {} : _a, _c = _b.round, round = _c === void 0 ? true : _c;
            var showDecimalPlaces = _this.block.settings.view.showDecimalPlaces;
            var idealDecimalPlaces = _this.idealDecimalPlaces();
            var actualDecimalPlaces = (0, GetDecimalPlaces_1.getDecimalPlaces)(amount);
            var decimalPlaces = 0;
            if (!showDecimalPlaces && actualDecimalPlaces === 0) {
                decimalPlaces = 0;
            }
            else if (!round && actualDecimalPlaces > idealDecimalPlaces) {
                decimalPlaces = actualDecimalPlaces;
            }
            else {
                decimalPlaces = idealDecimalPlaces;
            }
            return (0, FormatCurrency_1.formatCurrency)(amount, _this.getCurrencyCode(), decimalPlaces, _this.currencyLocaleProvider.currencyLocale);
        };
        this.formatStringWithCurrency = function (string) {
            return (0, FormatCurrency_1.formatStringWithCurrency)(string, _this.getCurrencyCode());
        };
        this.idealDecimalPlaces = function () {
            return currency_formatter_1.default.findCurrency(_this.getCurrencyCode()).decimalDigits;
        };
        this.getCurrencyCode = function () {
            return _this.block.settings.currency;
        };
        this.getSymbol = function () {
            return currency_formatter_1.default.findCurrency(_this.getCurrencyCode()).symbol;
        };
        this.parse = function (value) {
            return (0, FormatCurrency_1.parseCurrency)(value, _this.getCurrencyCode(), { locale: _this.currencyLocaleProvider.currencyLocale });
        };
    }
    return QuoteCurrencyFormatter;
}());
exports.default = QuoteCurrencyFormatter;
